'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./section-handler-widget');

mmWidgets.fn.nodeStyleEditorWidget = function (nodeStyleEditorModel, domLib) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			nodePreview = widget.find('[data-mm-role~="node-preview"]'),
			styleSelector = widget.find('[name="style-selector"]');
		widget.find('[data-mm-style-tool]').addClass('hidden');
		widget.find(`[data-mm-style-tool="${styleSelector.val()}"]`).removeClass('hidden');
		styleSelector.on('change', () => {
			widget.find('[data-mm-style-tool]').addClass('hidden');
			widget.find(`[data-mm-style-tool~="${styleSelector.val()}"]`).removeClass('hidden');
		});
		nodeStyleEditorModel.addEventListener('showNodePreview', (nodeView) => {
			widget.removeClass('hidden');
			const previewRect = nodePreview.parent().domElements[0].getBoundingClientRect(),
				node = {
					x: (previewRect.width - nodeView.metrics.width) / 2,
					y: (previewRect.height - nodeView.metrics.height) / 2,
					height: nodeView.metrics.height,
					width: nodeView.metrics.width
				};
			domLib.updateNodeContent(nodePreview.domElements[0], node, nodeView);
		});
		widget.find('[data-mm-role~=confirm]').on('click', nodeStyleEditorModel.saveChanges);
		nodeStyleEditorModel.addEventListener('hideEditor', () => widget.addClass('hidden'));
		nodeStyleEditorModel.addEventListener('showEditor', () => widget.removeClass('hidden'));
	});
};
